<template>
  <div>
    <!-- 小产品列表选择 -->
    <el-table v-loading="loading"
              :data="productData"
              style="width: 100%">
      <!-- 产品名称 -->
      <el-table-column width="70%"
                       label="产品库"
                       prop="spu_name">
        <template slot-scope="product_item">
          <div>
            <div id="spu_avata_area">
              <img style="height: 100%; weight: 100%"
                   :src="product_item.row.spu_avatar"
                   alt />
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="spu_name">
        <template slot-scope="product_title">
          <div>
            <span style="margin-right: 20px">{{
            product_title.row.spu_name
          }}</span>
            <el-tag effect="plain"
                    style="margin-right: 10px"
                    size="mini"
                    v-for="(item, index) in product_title.row.dest"
                    :key="index">{{ item }}</el-tag>
          </div>
          <div v-show="product_title.row.operator"
               style="font-size: 14px; color: lightgrey">
            服务商：
            <span style="margin-right: 20px">{{
            product_title.row.operator
          }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="140%"
                       align="right">
        <template slot="header"
                  slot-scope="searchProduct">
          <el-input v-model="search"
                    size="mini"
                    @change="searchProduct"
                    placeholder="输入关键字搜索" />
        </template>
        <template slot-scope="selectProduct">
          <el-button size="mini"
                     @click="choiceProduct(selectProduct.$index, selectProduct.row.spu_id)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination_product">
      <el-pagination @current-change="handleCurrentChange"
                     :current-page="pagenum"
                     :page-size="pagesize"
                     :total="total"
                     :small="true"
                     background
                     layout="prev, pager, next,slot">
        <span style="margin-left: 5px; cokor: #606266">共：{{ pagecount }} 页</span>
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product_mini_list',
  data() {
    return {
      loading: true,
      productData: [],
      search: '',
      pagenum: 1,
      pagesize: 12,
      //页数
      pagecount: -1,
      total: -1,
      //   productData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))
    }
  },
  created() {
    this.getProductList()
  },
  methods: {
    handleCurrentChange(val) {
      this.loading = true
      this.prodinfo = [{}, {}, {}, {}, {}, {}, {}]
      this.pagenum = val
      this.getProductList()
    },
    getProductList() {
      this.$http
        .get(
          `/product/get_product_list?p_no=${this.pagenum}&p_size=${this.pagesize}`
        )
        .then((res) => {
          console.log(res)
          this.productData = res.data.data
          this.pagecount = res.data.pages
          this.total = res.data.product_account
          this.loading = false
        })
    },
    choiceProduct(value, item) {
      let product_obj = {}
      this.$http.get(`/product/get_product?spu_id=${item}`).then((res) => {
        // console.log(res.data.data);
        product_obj.sku_list = res.data.data.skus
        product_obj.spu_id = item
        product_obj.spu_title = res.data.data.spu_name
        this.$emit('selectProduct', product_obj)
      })
    },
    // 获取产品数据，并把数据传出来
  },
}
</script>

<style>
#spu_avata_area {
  height: 40px;
  width: 40px;
}

.pagination_product {
  width: 100%;
  margin-top: 10px;
  text-align: right;
}
</style>